import { apiService } from "@/services/api";
import { createCrudStore } from "@/store/crudStore";

const base = createCrudStore("cheques");

export default {
  ...base,
  state: {
    ...base.state,
    cheques: [],
    alertas: null,
    loadingCheques: false,
  },
  getters: {
    ...base.getters,
    cheques(state) {
      return state.cheques;
    },
    alertas(state) {
      return state.alertas;
    },
    loadingCheques(state) {
      return state.loadingCheques;
    },
    chequesEnCartera(state) {
      return state.cheques.filter((c) => c.estado === "cartera");
    },
    chequesProximosVencer(state) {
      if (!state.alertas) return [];
      return state.alertas.proximos_a_cobrar || [];
    },
    chequesVencidos(state) {
      if (!state.alertas) return [];
      return state.alertas.vencidos || [];
    },
    chequesRechazados(state) {
      if (!state.alertas) return [];
      return state.alertas.rechazados || [];
    },
    totalAlertas(state) {
      if (!state.alertas?.resumen) return 0;
      const r = state.alertas.resumen;
      return (
        (r.cantidad_proximos || 0) +
        (r.cantidad_vencidos || 0) +
        (r.cantidad_rechazados || 0)
      );
    },
  },
  mutations: {
    ...base.mutations,
    setCheques(state, data) {
      state.cheques = data;
    },
    setAlertas(state, data) {
      state.alertas = data;
    },
    setLoadingCheques(state, val) {
      state.loadingCheques = val;
    },
    addCheque(state, cheque) {
      state.cheques.unshift(cheque);
    },
    updateChequeInList(state, updated) {
      const idx = state.cheques.findIndex((c) => c.id === updated.id);
      if (idx !== -1) state.cheques.splice(idx, 1, updated);
    },
    removeChequeFromList(state, id) {
      state.cheques = state.cheques.filter((c) => c.id !== id);
    },
  },
  actions: {
    ...base.actions,

    async getCheques({ commit }, params = {}) {
      commit("setLoadingCheques", true);
      try {
        let url = "cheques/cheques/";
        const q = [];
        if (params.estado) q.push(`estado=${params.estado}`);
        if (params.tipo) q.push(`tipo=${params.tipo}`);
        if (q.length) url += "?" + q.join("&");
        const response = await apiService.getCustom(url);
        commit("setCheques", response.data);
        return response.data;
      } finally {
        commit("setLoadingCheques", false);
      }
    },

    async crearCheque({ commit }, payload) {
      const response = await apiService.postCustom("cheques/cheques/", payload);
      commit("addCheque", response.data);
      return response.data;
    },

    async actualizarCheque({ commit }, { id, payload }) {
      const response = await apiService.patchCustom(
        `cheques/cheques/${id}/`,
        payload
      );
      commit("updateChequeInList", response.data);
      return response.data;
    },

    async eliminarCheque({ commit }, id) {
      await apiService.deleteCustom(`cheques/cheques/${id}/`);
      commit("removeChequeFromList", id);
    },

    async depositarCheque({ commit }, { id, banco }) {
      const response = await apiService.postCustom(
        `cheques/cheques/${id}/depositar/?banco_deposito=${encodeURIComponent(
          banco
        )}`
      );
      commit("updateChequeInList", response.data);
      return response.data;
    },

    async cobrarCheque({ commit }, id) {
      const response = await apiService.postCustom(
        `cheques/cheques/${id}/cobrar/`
      );
      commit("updateChequeInList", response.data);
      return response.data;
    },

    async rechazarCheque({ commit }, { id, motivo }) {
      const response = await apiService.postCustom(
        `cheques/cheques/${id}/rechazar/?motivo=${encodeURIComponent(motivo)}`
      );
      commit("updateChequeInList", response.data);
      return response.data;
    },

    async endosarCheque({ commit }, { id, endosadoA }) {
      const response = await apiService.postCustom(
        `cheques/cheques/${id}/endosar/?endosado_a=${encodeURIComponent(
          endosadoA
        )}`
      );
      commit("updateChequeInList", response.data);
      return response.data;
    },

    async getAlertas({ commit }, diasAnticipacion = 7) {
      try {
        const response = await apiService.getCustom(
          `cheques/cheques/alertas/?dias_anticipacion=${diasAnticipacion}`
        );
        commit("setAlertas", response.data);
        return response.data;
      } catch (error) {
        console.error("Error obteniendo alertas de cheques:", error);
        return null;
      }
    },
  },
};
